import $ from 'jquery';

class Helper {

  constructor(helper) {
    this.elm = helper;
    this.forms = $(this.elm).find('input, textarea, select');

    const data = $(this.elm).data('helper');

    this.target = $(`#${data.target}`).first();

    if (this.target.length < 1) {
      console.error('Helper target not found. Use some real ID');
    }

    this.title = data.title;
    this.content = data.content;

    $(this.elm)
      .on('mouseenter', (event) => {
        this.activeHelper();
      })

    $(this.forms)
      .on('focus', (event) => {
        this.activeHelper();
      })
  }

  activeHelper() {
    let targetTitle = $(this.target).find('.c-helper__topic__title');
    let targetText = $(this.target).find('.c-helper__topic__text');

    targetTitle.html(this.title);
    targetText.html(this.content);
  }
}

class HelperControll {
  constructor() {
    this.activeHelper = [];

    const helpers = $('*[data-helper]');
    if (helpers.length) {
      helpers.each((index, helper) => {
        this.activeHelper.push( new Helper(helper) );
      });
    }
  }
}

export default new HelperControll;
